import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
//UI
import { Button, Modal, Icon, Accordion, Loader, Message } from "semantic-ui-react";
import { ExpandLess, ExpandMore } from "@material-ui/icons";
import { Collapse } from "@material-ui/core";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import CircularProgress from "@material-ui/core/CircularProgress";
import Divider from "@material-ui/core/Divider";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import SearchIcon from "@material-ui/icons/Search";
import InputBase from "@material-ui/core/InputBase";
import Fab from "@material-ui/core/Fab";
import AddIcon from "@material-ui/icons/Add";
import useStyles from "../../styles/Common";
import "../../styles/common.css";
//ACTIONS
import { initialStateGuideOnBoard } from "../../../redux/actions/reservations/guideOnBoard/fetchGuideOnBoard";
import { deleteGuideOnBoard } from "../../../redux/actions/reservations/guideOnBoard/deleteGuideOnBoard";
import { fetchGuideOnBoardLogs } from "../../../redux/actions/reservations/guideOnBoard/fetchGuideOnBoardLogs";
import { fetchGuideOnBoardListCustom } from "../../../redux/slices/custom/reservations/guideOnBoard/customGuideOnBoardList.slice";
//RESOURCES
import LogsHistory from "../../../components/reservation/logsHistory";
import { scrollToTop } from "../../resources/utils";

export default function GuideOnBoardList() {
  let { cruise_id } = useParams();
  const { t } = useTranslation();
  const classes = useStyles();
  const [openHistory, setOpenHistory] = useState(false);
  const guidesOnBoardStateCustom = useSelector((state) => state.customGuideOnBoardList);
  const guideOnBoardLogState = useSelector((state) =>state.guideOnBoardLogReducer)
  const guidesOnBoardState = useSelector((state) => state.guideOnBoardReducer);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchGuideOnBoardListCustom(cruise_id));
    scrollToTop();
  }, [dispatch, cruise_id]);

  if (guidesOnBoardStateCustom.fetching || guidesOnBoardState.fetching) {
    return <CircularProgress />;
  }

  if (guidesOnBoardStateCustom.processing) {
    return <CircularProgress />;
  }

  if (guidesOnBoardState.message === "resource deleted successfully") {
    dispatch(fetchGuideOnBoardListCustom(cruise_id));
    dispatch(fetchGuideOnBoardLogs(cruise_id));
    dispatch(initialStateGuideOnBoard());
  }

  const handledeleteGuideOnBoard = (id) => {
    dispatch(deleteGuideOnBoard(cruise_id, id));
  };

  const handleHistoyClick = () => {
    setOpenHistory(!openHistory);
    if (!openHistory ) {
      dispatch(fetchGuideOnBoardLogs(cruise_id));
    } 
  };

  return (
    <>
      {guidesOnBoardState.error ? (
        <Message negative content={t(guidesOnBoardState.error)} />
      ) : (
        ""
      )} 
      <div className="ui breadcrumb">
        <Link to={`/cruises/${cruise_id}/cruise-detail`} className="section">
          TipTops
        </Link>
        <div className="divider">/</div>
        {guidesOnBoardStateCustom.guidesOnBoard.map((cruiseItem, index) => (
          <div key={index} className="active section">
            {cruiseItem.cruise_code
              ? cruiseItem.cruise_code
              : guidesOnBoardStateCustom.cruise.code}
          </div>
        ))}
      </div>
      <br></br>
      <br></br>
      <TableContainer component={Paper}>
        <Toolbar>
          <Typography className={classes.title} variant="h6" noWrap>
            Guías {guidesOnBoardStateCustom.message}
            <Link to={`/cruises/${cruise_id}/guides_new`}>
              <Fab
                size="small"
                color="primary"
                aria-label="add"
                className={classes.margin}
              >
                <AddIcon />
              </Fab>
            </Link>
          </Typography>
          <div className={classes.search}>
            <div className={classes.searchIcon}>
              <SearchIcon />
            </div>
            <InputBase
              placeholder="Buscar…"
              classes={{
                root: classes.inputRoot,
                input: classes.inputInput,
              }}
              inputProps={{ "aria-label": "search" }}
            />
          </div>
        </Toolbar>
        <Divider variant="middle" />
        <Table className={classes.table} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell>Nombre</TableCell>
              <TableCell>Idioma</TableCell>
              <TableCell>Orden</TableCell>
              <TableCell></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {guidesOnBoardStateCustom.guidesOnBoard.map((cruiseItem) =>
              cruiseItem.guides.map((guide) => (
                <TableRow key={guide.id}>
                  <TableCell>
                    {guide.first_name} {guide.last_name}
                  </TableCell>
                  <TableCell>{guide.language_name}</TableCell>
                  <TableCell>{guide.order}</TableCell>

                  <TableCell align="right">
                    <Link to={`/cruises/${cruise_id}/guides/${guide.id}`}>
                      <Button className="edit_button" icon>
                        <Icon className="icon_color" name="pencil alternate" />
                      </Button>
                    </Link>
                    <Modal
                      trigger={
                        <Button className="ui button delete_button" icon>
                          <Icon name="trash alternate" className="icon_color" />
                        </Button>
                      }
                      content={`¿Quieres eliminar este guía?`}
                      actions={[
                        "Cancelar",
                        {
                          key: "eliminar",
                          content: "Eliminar",
                          className: "delete_button icon_color",
                          onClick: () => handledeleteGuideOnBoard(guide.id),
                        },
                      ]}
                      size="tiny"
                    />
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <br />
      <Accordion styled style={{ width: "91vw" }}>
        <Accordion.Title onClick={handleHistoyClick} style={{ display: "flex", gap: "5px" }}>
          {t("log_historical")}
          {openHistory ? <ExpandLess /> : <ExpandMore />}
        </Accordion.Title>
        {guideOnBoardLogState.fetching  ? (
          <div style={{ display: "flex", width: "91vw", height: "80px", justifyContent: "center" }}>
            <Loader size="medium" active inline>Loading...</Loader>
          </div>
        ) : (
          <Collapse in={openHistory} timeout="auto" unmountOnExit style={{ padding: "15px" }}>
            <LogsHistory
              logsHistory={guideOnBoardLogState.logs}
            />
          </Collapse>
        )}
      </Accordion>
    </>
  );
}
